// Routes ///////////////////////////////////////////////////////////////
export const ProductsRoute = (): string => `/products`;

// API //////////////////////////////////////////////////////////////////
